<template>
    <svg @mouseup="e => $emit('mouseup', e)" ref="preview" />
</template>

<script>
import { applyShadesOnSvg, updateSvgID, applyReferencesOnSvg, stripSvg, CUSTOM_EVENTS } from "@/plano/elements";

// TODO Remove Menu from Module Preview
export default {
    props: {
        element: Object,
        groups: Array,
        shadeByGroup: Object,
        /** @type {Array<{ productId: number, productName: Translation, shades: Shade[] }>} */
        shadesPerProduct: Array,
        /** @type { [tester: string] : color: string } */
        highlightTester: {
            type: Object
        },
        size: Number,
        index: Number
    },
    watch: {
        size() {
            this.paint();
        },
        shadeByGroup() {
            this.paint();
        },
        highlightTester() {
            this.paint();
        }
    },
    methods: {
        paint() {
            applyShadesOnSvg(this.$refs.preview, this.shadeByGroup, this.groups, this.shadesPerProduct);
            applyReferencesOnSvg(this.$refs.preview, this.shadeByGroup, this.groups, this.shadesPerProduct, this.highlightTester);
        },
        openMenu(e) {
            const { x, y } = e.pos;
            const textNode = e.textNode;

            this.$emit("openMenu", { x, y, textNode, index: this.index });
        },
        closeMenu() {
            this.$emit("closeMenu");
        },
        checkMenu() {
            this.$emit("checkMenu");
        }
    },
    mounted() {
        /** @type {SVGElement} */
        const preview = this.$refs.preview;
        const g = stripSvg(Context.svgImages[this.element.imageURL].node).cloneNode(true);

        preview.appendChild(g);
        updateSvgID(preview);
        applyShadesOnSvg(preview, this.shadeByGroup, this.groups, this.shadesPerProduct);
        applyReferencesOnSvg(preview, this.shadeByGroup, this.groups, this.shadesPerProduct, this.highlightTester);
        window.addEventListener("click", this.checkMenu);
        window.addEventListener(CUSTOM_EVENTS.openHighlightMenu, this.openMenu);
    },
    beforeDestroy() {
        window.removeEventListener("click", this.checkMenu);
        window.removeEventListener(CUSTOM_EVENTS.openHighlightMenu, this.openMenu);
    }
};
</script>

<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// module-preview.vue?ca22f364